import React, { Component } from 'react'
import { Modal, Button } from 'react-bootstrap'
import {reduxForm, Field} from 'redux-form'
import { Row } from 'react-bootstrap'
import { required } from '../../util/validationFunctions'
import InputText from '../comun/form/InputText'
import InputTextArea from '../comun/form/InputTextArea'
import InputCheckBox from '../comun/form/InputCheckBox'

class ModalConductor extends Component {
  submitNuevoConductor (values) {
    if (Object.keys(this.props.transporte.conductorRecuperar).length > 0){
      this.props.actions.editConductorAnadido(values)
    } else {
      return new Promise((resolve, reject) => {
        this.props.actions.submitNuevoConductor(values, () => {
        resolve()
      }, reject)
    })
    .then(() => { console.log('completado') })
    .catch(() => { console.log('error') })
    }
  }
  guardarYNuevoConductor(values){
    this.props.actions.guardarYNuevoConductor(values)
    this.props.initialize({activo: true, predefinido: false})
  }
  render () {
    const {
      t, handleSubmit, submitting,
      transporte:{showModalConductor, conductorRecuperar, duplicar, duplicarConductor},
      actions: {closeModalConductor}
    } = this.props
    return (
      <Modal show={showModalConductor} onHide={closeModalConductor} aria-labelledby="contained-modal-title-lg" backdrop="static">
      <form className="form-modal-conductor">
        <Modal.Header closeButton>
          <Modal.Title>
          {
            t('TRANSPORTE.NUEVO_TRANSPORTE.MODAL_CONDUCTOR.TITLE')
          }
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row>
              <Field
                colSm={4}
                id="nombre-conductor"
                name="nombreConductor"
                component={InputText}
                controlLabel={t('TRANSPORTE.NUEVO_TRANSPORTE.MODAL_CONDUCTOR.NOMBRE') + '*'}
                customClass='nombre-conductor'
                validate={required}
                maxLength={true}
                valorMaxLength={50}
              />
              <Field
                colSm={4}
                id="dniConductor"
                name="dniConductor"
                component={InputText}
                controlLabel={t('TRANSPORTE.NUEVO_TRANSPORTE.MODAL_CONDUCTOR.DNI')}
                customClass='dni-conductor'
                maxLength={true}
                valorMaxLength={20}
              />
              <Field
                colSm={4}
                id="movilConductor"
                name="movilConductor"
                component={InputText}
                controlLabel={t('TRANSPORTE.NUEVO_TRANSPORTE.MODAL_CONDUCTOR.MOVIL')}
                maxLength={true}
                valorMaxLength={50}
              />
              <Field
                id="activo-conductor"
                name="activo"
                colSm={12}
                inline
                component={InputCheckBox}
                claseActivo="onoffswitch-label"
                controlLabel={t('TRANSPORTE.NUEVO_TRANSPORTE.MODAL_CONDUCTOR.ACTIVO')}
              />
              <Field
                id="predefinido"
                name="predefinido"
                colSm={12}
                inline
                component={InputCheckBox}
                claseActivo="onoffswitch-label"
                controlLabel={t('TRANSPORTE.NUEVO_TRANSPORTE.MODAL_CONDUCTOR.PREDEFINIDO')}
              />
          </Row>
        </Modal.Body>
        <Modal.Footer>
          {
            Object.keys(conductorRecuperar).length === 0 && Object.keys(duplicarConductor).length === 0 && (
              <Button type="button" className="btn btn-primary" onClick={handleSubmit(this.guardarYNuevoConductor.bind(this))}>{t('TRANSPORTE.NUEVO_TRANSPORTE.MODAL_CONDUCTOR.GUARDAR_Y_NUEVO')}</Button>
            )
          }
          <Button 
            type="button"
            className={"btn btn-primary" + (submitting ? ' disabled' : '')}
            onClick={!submitting ? handleSubmit(this.submitNuevoConductor.bind(this)) : null}>{t('TRANSPORTE.NUEVO_TRANSPORTE.MODAL_CONDUCTOR.GUARDAR')}</Button>
          <Button type="button" className="btn btn-white" onClick={closeModalConductor}>{t('TRANSPORTE.NUEVO_TRANSPORTE.MODAL_CONDUCTOR.CANCELAR')}</Button>
        </Modal.Footer>
        </form>
      </Modal>
    )
  }
}

export default (reduxForm({
  form: 'ModalConductor'
})(ModalConductor))